import { api } from './client';

export type RiskTier = 'A' | 'B' | 'C' | 'D';

export interface BackendFiveCFactors {
  capacity: number;
  character: number;
  capital: number;
  collateral: number;
  conditions: number;
}

export interface BackendRiskProfile {
  _id: string;
  subjectId: string;
  subjectType: 'FARMER' | 'HTX';
  factors: BackendFiveCFactors;
  dscr?: number;
  suggestedTier?: RiskTier;
  assignedTier?: RiskTier;
  redFlags: string[];
  overrideReason?: string;
  overrideExpiresAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface HtxAverageRiskScore {
  totalCount: number;
  scoredCount: number;
  averageScore: number | null;
  tierCounts: Record<string, number>;
}

export interface BackendCreditSignal {
  _id: string;
  subjectId: string;
  factorTag: 'C1_CAPACITY' | 'C2_CHARACTER' | 'C3_CAPITAL' | 'C4_COLLATERAL' | 'C5_CONDITIONS';
  sourceEventType: string;
  normalizedScore: number;
  isRedFlag: boolean;
  redFlagCode?: string;
  extractedAt: string;
}

/** Returns null when the farmer has no RiskProfile yet — a profile is only
 * lazily created on the farmer's first qualifying credit signal (eKYC event,
 * loan/contract activity, harvest confirmed, etc.), not at registration. */
export async function getRiskProfile(subjectId: string): Promise<BackendRiskProfile | null> {
  return api.get<BackendRiskProfile | null>(`/risk/profiles/FARMER/${subjectId}`);
}

export async function getHtxAverageRiskScore(htxId: string): Promise<HtxAverageRiskScore> {
  return api.get<HtxAverageRiskScore>(`/risk/htx/${htxId}/average-score`);
}

/** The concrete, literal proof that "upload tài liệu"/"cập nhật eKYC" actually
 * feed the 5C score — each row here is one real event (ekyc.verified,
 * farmer.attachment_added, harvest.confirmed, ...) that moved one factor. */
export async function getRiskSignalTimeline(subjectId: string): Promise<BackendCreditSignal[]> {
  return api.get<BackendCreditSignal[]>(`/risk/profiles/FARMER/${subjectId}/signals`);
}
